import React from 'react';
import bemify from 'bemify-js';

//import Link from 'app/common/components/Link';

import BashCodeBlock from '../components/BashCodeBlock';
import Code from '../components/Code';
import Paragraph from '../components/Paragraph';
import StepTitle from '../components/StepTitle';
import SyntaxHighlighter from '../components/SyntaxHighlighter';

const bem = bemify('testing');

const codeBlock = `# CLIENT_ID=1234
# CLIENT_SECRET=asdf`;

//const repoCodeBlock = `const REPO = 'username/reponame' // CHANGE THIS`;

const codeBlock2 = `Validating project locally
No structural errors found during validation routine.
This project is structurally sound!

✔ Running integration checks ... 22 checks passed
Adding /Users/marinahand/.zapierrc to environment as ZAPIER_DEPLOY_KEY...
Running test suite with the following command:

  npm run --silent test --

 PASS  test/authentication.test.js
  oauth2 app
    ✓ generates an authorize URL (30 ms)

Test Suites: 1 passed, 1 total
Tests:       1 passed, 1 total
Snapshots:   0 total
Time:        2.56 s
Ran all test suites.
`;

const Testing = () => (
  <div className={bem()}>
    <StepTitle>Testing Your App</StepTitle>
    <Paragraph>
      The CLI includes automated testing using the Jest testing framework. This
      is a super useful tool and it's a highly encouraged development practice
      to have as much test coverage as possible for your app.
    </Paragraph>
    <Paragraph>
      To test the GitHub example app we'll need to set up some local environment
      variables so that the tests can connect to your account and test repo.
    </Paragraph>
    <Paragraph>
      Open the <Code>.env</Code> file. You'll see some variables with some
      placeholders.
    </Paragraph>
    <SyntaxHighlighter language="bash">{codeBlock}</SyntaxHighlighter>
    <Paragraph>
      Replace those with your GitHub Client ID and Client Secret, removing the #
      and save the file.
    </Paragraph>
    <Paragraph>
      Now, go ahead and run <Code>zapier test</Code>.
    </Paragraph>
    <BashCodeBlock
      lines={[
        {
          content: 'zapier test',
          isCommand: true,
        },
      ]}
    />
    <Paragraph>If everything worked you'll see a message like:</Paragraph>
    <SyntaxHighlighter language="text">{codeBlock2}</SyntaxHighlighter>
    <Paragraph>
      Note that this tutorial includes limited tests to illustrate the
      capabilities. You’ll want to write more comprehensive tests for your
      integration.
    </Paragraph>
    <Paragraph>
      If you get errors, try <Code>zapier test --debug</Code> to get more
      information. Check your <Code>.env</Code> file to confirm everything looks
      right there.
    </Paragraph>
  </div>
);

export default Testing;
